<template>

  <div>
    <div
      class="buymodal-block__body">

      <div
        class="body-info">
        <div
          class="body-info__title">
          Подписание договора
        </div>
        <div
          class="body-info__block double">
          <div
            class="info-table">
            <div
              class="info-table__line">
              <div
                class="label">
                Телефон
              </div>
              <div
                class="value">
                {{ clientInfo.telefon }}
              </div>
            </div>
          </div>
          <div
            class="info-table">
            <div
              class="info-table__line">
              <div
                class="label" v-if="user.flowType != 'mvm'">
                <a
                  :href="newOrder.pdflink"
                  v-if="newOrder.pdflink"
                  download
                  target="_blank"
                  class="btn cancel"
                  style="text-decoration: none">
                  Договор
                </a>
              </div>
              <div
                class="label" v-if="user.flowType == 'mvm'">
                <a
                  href="https://mvm.tradein.tki.ltd/docs/offer"
                  download
                  target="_blank"
                  class="btn cancel"
                  style="text-decoration: none">
                  Оферта
                </a>
              </div>
              <div
                class="value">
                
              </div>
            </div>
          </div>
          <div
            class="info-table">
            <div
              class="info-table__line">
              <div
                class="label">

                <!-- <button
                    type="button"
                    class="btn next"
                    @click.prevent="send()"
                    v-if="sendCode">
                    Отправить код в СМС
                    <v-progress-circular v-if="loader"
                      :size="18"
                      :width="4"
                      color="white"
                      indeterminate
                    ></v-progress-circular>
                </button> -->

                <button
                    type="button"
                    class="btn next"
                    @click.prevent="send()"
                    v-if="repeatSendCode">
                    Отправить код повторно
                    <v-progress-circular v-if="loader"
                      :size="18"
                      :width="4"
                      color="white"
                      indeterminate
                    ></v-progress-circular>
                </button>
                
                <!-- <div
                  v-if="errors.send"
                  class="error-mess">
                  <br>
                  {{errors.send}}
                </div> -->
                <div
                  v-if="info.code"
                  class="error-mess">
                  <br>
                  Код из смс: {{info.code}}
                </div>

                <div v-if="!sendCode && !repeatSendCode && !callType" >
                  <br>
                  Код для подписи отправлен. Повторно отправить код можно через {{secondsLeft}} секунд
                </div>
              </div>
              <div
                class="value">
                
              </div>
            </div>
          </div>
        </div>
          
          

          <div class="body-info__block">
            <div
              class="info-user"
              v-if="enterCode">
              <div
                class="info-user__line"
                v-if="enterCode">
                <input
                  class="inpt"
                  v-model.trim="code"
                  v-mask="'####'"
                  id="code"
                  :class="code ? 'active' : ''" />
                <label
                  for="code"
                  class="label"
                  v-if="!callType">
                  
                  Код из СМС 
                </label>
                <label
                  for="code"
                  class="label"
                  v-if="callType">
                  
                  Последние 4 цифры номера 
                </label>
                <span
                  v-if="errors.code"
                  class="error-mess">
                  {{errors.code}}
                </span>
              </div>
              
            
            </div>

          </div>
      </div>
      
    </div>
    <div
      class="buymodal-block__footer">
      <button
        type="button"
        class="btn cancel"
        @click.prevent="changeInfo()">
        Изменить номер телефона
      </button>
      <button
        type="button"
        class="btn cancel"
        @click.prevent="$emit('leave')">
        Отказаться
      </button>
      <button
        type="button"
        class="btn next"
        v-if="enterCode"
        @click.prevent="check()">
        Подписать
        <v-progress-circular v-if="loader"
                      :size="18"
                      :width="4"
                      color="white"
                      indeterminate
                    ></v-progress-circular>
      </button>
    </div>

  </div>

</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';

export default {
  data() {
    return {  
      sendCode: false,
      enterCode: true,
      repeatSendCode: false,
      secondsLeft: 0,
      callType: false,
      code: '',
      loader: false,
      info: {
        code: false,
      },
      errors: {
        code: false,
        send: false
      }
    }
  },
  computed: {
    ...mapState('buyphones', ['model', 'newOrder', 'clientInfo']),
    ...mapState('user', ['user'])
  },
  methods: {
    ...mapActions('buyphones', ['sendSms','checkCode']),
    ...mapMutations('buyphones', ['CHANGE_SCREEN_THREE']),
    

    changeInfo() {
      this.CHANGE_SCREEN_THREE({ show2: true, show3: false, show4: false });
    },
    updateSeconds(sec){
      setTimeout(() =>  this.repeatSendCode = true, sec * 1000);
      var updateSecond = setInterval(() => {
        this.secondsLeft -= 1; 
        if(this.secondsLeft < 1){
          clearInterval(updateSecond)
        }}, 1000);
    },
    async send() {
      this.loader = true
      this.errors.send = false
      this.info.code = false
      var sendData = {
        "contractId": this.model.btag,
        "phoneNumber": this.clientInfo.telefon
      }
      var res = await this.sendSms(sendData)

      if (res.status == 'ok'){
        this.callType == false
        if (res.codeType == "call"){
          this.callType = true
        }
        this.info.code = res.code
        this.sendCode = false;
        this.repeatSendCode = false;
        this.enterCode = true;
        this.secondsLeft = 120
        this.updateSeconds(this.secondsLeft)
      }else{
        this.errors.send = res.errorRu
      }
      this.loader = false
    },
    async check(){
      this.loader = true
      this.errors.code = false
      var sendData = {
        "contractId": this.model.btag,
        "code": this.code
      }
      var res = await this.checkCode(sendData)
      if (res.status == 'ok'){
        this.newOrder.signContract = res.pdflink
        this.newOrder.shopdoc = res.shopdoc
        this.next()
      }else{
        this.errors.code = res.errorRu
      }
      this.loader = false
    },
    next() {
      this.$emit('changeScreen');
    },
  },
  beforeMount() {
   this.secondsLeft = 120
   this.updateSeconds(this.secondsLeft)
  },
}
</script>

<style lang="css">
</style>
